<div [hidden]="!active" class="tab-induxtry" [ngStyle]="styleTab">
    <ng-content></ng-content>
</div>